import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Formik } from "formik";
import formClasses from "../Mitglied/Mitglied.module.css";
import Field from "../Mitglied/Field/Field";

import axios from "../../axios";
import Header from "../../Layout/Header/Header";
import Controls from "../../Components/Controls/Controls";

const TermineDetails = (props) => {
  const { id } = useParams();
  const [detaills, setDetaills] = useState({});
  const [signedUp, setSignedUp] = useState(false);

  useEffect(() => {
    axios
      .get(`/collections/get/date?filter[_id]=${id.split("-")[1]}`)
      .then((res) => {
        setDetaills(res.data.entries[0]);
      });
  }, [id]);

  return (
    <div>
      <Header small={true} />
      <main>
        <Controls to="/termine" />
        <div dangerouslySetInnerHTML={{ __html: detaills.text }}></div>

        {detaills.has_signup ? (
          <section className={formClasses.FormSection}>
            <h2 className={formClasses.FormTitle}>Anmeldung</h2>
            <h3 className={formClasses.FormSubtitle}>
              {detaills.signup_title}
            </h3>
            {signedUp ? (
              <p>
                Vielen Dank, Ihre Anmeldung ist erfolgreich bei uns
                eingegangen.
              </p>
            ) : (
              <Formik
                initialValues={{
                  name: "",
                  last_name: "",
                  amount_of_people: "",
                  comment: "",
                }}
                validate={(values) => {
                  const errors = {};

                  if (!values.name) errors.name = "Pflichtfeld";
                  if (!values.last_name) errors.last_name = "Pflichtfeld";
                  if (!values.amount_of_people)
                    errors.amount_of_people = "Pflichtfeld";

                  return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                  axios
                    .post(
                      "https://admin.alt-opel-schweiz.ch/mail.php",
                      new URLSearchParams({
                        ...values,
                        event_id: detaills._id,
                        event_name: detaills.title,
                        to: detaills.signup_recipient,
                        token: "3077e8a161ad7ac23b5e23b68655014f8a7e6f05e433b18f",
                      }),
                    )
                    .then((res) => {
                      setSignedUp(true);
                    })
                    .catch((err) => {
                      alert(
                        "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut oder drucken Sie das Formular aus und füllen es manuell aus.",
                      );
                    });

                  setSubmitting(false);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div className={formClasses.FlexRow}>
                      <Field
                        label="Name*"
                        placeholder="Name"
                        name="name"
                        onChange={(e) => handleChange(e)}
                        onBlur={handleBlur}
                        value={values.name}
                        error={errors.name && touched.name && errors.name}
                      />

                      <Field
                        label="Nachname*"
                        placeholder="Nachname"
                        name="last_name"
                        onChange={(e) => handleChange(e)}
                        onBlur={handleBlur}
                        value={values.last_name}
                        error={
                          errors.last_name &&
                          touched.last_name &&
                          errors.last_name
                        }
                      />
                    </div>

                    <Field
                      type="number"
                      label="Anzahl Personen*"
                      placeholder="1"
                      name="amount_of_people"
                      onChange={(e) => handleChange(e)}
                      onBlur={handleBlur}
                      value={values.amount_of_people}
                      error={
                        errors.amount_of_people &&
                        touched.amount_of_people &&
                        errors.amount_of_people
                      }
                    />

                    <section
                      dangerouslySetInnerHTML={{
                        __html: detaills.signup_description,
                      }}
                    ></section>

                    <Field
                      type="textarea"
                      label="Kommentar"
                      placeholder="Kommentar"
                      name="comment"
                      onChange={(e) => handleChange(e)}
                      onBlur={handleBlur}
                      value={values.comment}
                    />

                    <button
                      className="Button"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {detaills.signup_submit}
                    </button>
                  </form>
                )}
              </Formik>
            )}
          </section>
        ) : null}
      </main>
    </div>
  );
};

export default TermineDetails;
